import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewFeaturingArtistInputFieldName =
  'has_music_featuring_artists'|['music_featuring_artists', number, 'name'|'name_en'|'name_kana'];
type MusicAlbumEditForm3EditPopupViewFeaturingArtistInputItemName = 'music_featuring_artists';

/**
 * フィーチャリングアーティスト入力
 */
export default function MusicAlbumEditForm3EditPopupViewFeaturingArtistInput({
  getNumberOfItems,
  addItem,
  getValue,
  setValue,
  getErrors,
} : {
  getNumberOfItems: (name: MusicAlbumEditForm3EditPopupViewFeaturingArtistInputItemName) => number,
  addItem: (name: MusicAlbumEditForm3EditPopupViewFeaturingArtistInputItemName, self: boolean) => void,
  getValue: (name: MusicAlbumEditForm3EditPopupViewFeaturingArtistInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewFeaturingArtistInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewFeaturingArtistInputFieldName) => FieldValidationErrorsType,
}) {
  const hasMusicFeaturingArtistsOptions = [
    { title: 'あり', value: '1' },
    { title: 'なし', value: '0' },
  ];

  return (
    <>
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">フィーチャリングアーティスト</label>
        </dt>
        <dd>
          <CustomRadio
            options={hasMusicFeaturingArtistsOptions}
            value={getValue('has_music_featuring_artists')}
            setValue={(value) => setValue('has_music_featuring_artists', value)}
            validationErrors={getErrors('has_music_featuring_artists')}
          />
        </dd>
      </dl>
      {getValue('has_music_featuring_artists') !== '0' && [...Array(getNumberOfItems('music_featuring_artists')).keys()].map((index) => (
        <React.Fragment
          key={index} // eslint-disable-line react/no-array-index-key
        >
          <div className="parent_body mb-0">
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">フィーチャリングアーティスト名</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="Frekul Singer"
                  value={getValue(['music_featuring_artists', index, 'name'])}
                  setValue={(value) => setValue(['music_featuring_artists', index, 'name'], value)}
                  validationErrors={getErrors(['music_featuring_artists', index, 'name'])}
                />
              </dd>
            </dl>
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">ひらがな​</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="ふりくるしんがー"
                  value={getValue(['music_featuring_artists', index, 'name_kana'])}
                  setValue={(value) => setValue(['music_featuring_artists', index, 'name_kana'], value)}
                  validationErrors={getErrors(['music_featuring_artists', index, 'name_kana'])}
                />
              </dd>
            </dl>
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">海外向け（英語またはローマ字）</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="Frekul Singer"
                  value={getValue(['music_featuring_artists', index, 'name_en'])}
                  setValue={(value) => setValue(['music_featuring_artists', index, 'name_en'], value)}
                  validationErrors={getErrors(['music_featuring_artists', index, 'name_en'])}
                />
              </dd>
            </dl>
          </div>
        </React.Fragment>
      ))}
      {getValue('has_music_featuring_artists') !== '0' && getNumberOfItems('music_featuring_artists') < 3 && (
        <dl>
          <dd>
            <CustomButton type="add" onClick={() => addItem('music_featuring_artists', false)}>
              <span>フィーチャリングアーティストの追加</span>
            </CustomButton>
          </dd>
        </dl>
      )}
    </>
  );
}

